import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
const digits = (Number)=>{
	Number+= '';
	Number= Number.replace(',', ''); Number= Number.replace(',', ''); Number= Number.replace(',', '');
	Number= Number.replace(',', ''); Number= Number.replace(',', ''); Number= Number.replace(',', '');
	const x = Number.split('.');
	let y = x[0];
	const z= x.length > 1 ? '.' + x[1] : '';
	const rgx = /(\d+)(\d{3})/;
	while (rgx.test(y))
		y= y.replace(rgx, '$1' + ',' + '$2');
	return y+ z;
}
const Plan = () => {
	const [plans, setPlans] = useState([])
	const [videoLimits, setVideoLimits] = useState([])
	const [userLimits, setUserLimits] = useState([])
	const [selectedVideoLimit, setSelectedVideoLimit] = useState('')
	const [selectedUserLimit, setSelectedUserLimit] = useState('')
	const [selectedMonth, setSelectedMonth] = useState(1)
	const [selectedPercent, setSelectedPercent] = useState(1)

	const [loading,setLoading] = useState(true)

  useEffect(() => {
    const getPlans = async () => {
      try {
        const {data} = await axios.get(process.env.NODE_ENV !== "production" ? 'https://localhost:3000/api/plans' : 'https://online.bellmeet.com/api/plans')
        const plansArr = data.plans || []
        let listVideoLimits = []
				let listUserLimits = []
				plansArr.forEach((plan) => {
          if (!listVideoLimits.includes(plan.video_limit)) listVideoLimits.push(plan.video_limit)
					if (!listUserLimits.includes(plan.max_user)) listUserLimits.push(plan.max_user)
				})
        setVideoLimits(listVideoLimits)
				setUserLimits(listUserLimits)
				setPlans(plansArr)
				setLoading(false)
      } catch (e) {
        console.log(e)
      }
    }

    getPlans()
  }, [])
	const { t } = useTranslation('common')
	return (
		<div style={{direction: "rtl"}} className={'plans-wrap'}>
			<div className={'plan-filter'}>
				<span>{t('NumberVideo')}</span>
				<ul>
					<li onClick={() => setSelectedVideoLimit('')}
							className={selectedVideoLimit === '' ? 'active' : ''}>{t('ECOMMERCE.COMMON.ALL')}
					</li>
					{videoLimits.map(((value, index) => {
						return (
							<li onClick={() => setSelectedVideoLimit(value)}
									className={selectedVideoLimit === value ? 'active' : ''} key={index}>{value} {t('Video')} </li>
						)
					}))}
				</ul>
				<span>{t('NumberUser')}</span>
				<select style={{
					marginBottom:"4em"
				}} onChange={(e)=>{
					const v = e.target.value
					setSelectedUserLimit(v)
				}}>
					<option value={''}>
						{t('ECOMMERCE.COMMON.ALL')}
					</option>
					{userLimits.map(((v, index) => {
						return (
							<option value={v} key={index}>
								{v} {t('User')}
							</option>
						)
					}))}
				</select>
				<select defaultValue={selectedMonth} onChange={(e) => {
					const value = Number(e.target.value)
					setSelectedMonth(value)
					switch (value) {
						case 1:
							setSelectedPercent(1)
							break;
						case 3:
							setSelectedPercent(0.9)
							break;
						case 6:
							setSelectedPercent(0.85)
							break;
						case 9:
							setSelectedPercent(0.8)
							break;
						case 12:
							setSelectedPercent(0.75)
							break;
						default :
							setSelectedPercent(1)
					}
				}}>
					<option value={1}> 1{t('Months')} ({t('None')} {t('Discount')})</option>
					<option value={3}> 3{t('Months')} ({t('10%')} {t('Discount')})</option>
					<option value={6}> 6{t('Months')} ({t('15%')} {t('Discount')})</option>
					<option value={9}> 9{t('Months')} ({t('20%')} {t('Discount')})</option>
					<option value={12}> 1{t('Years')} ({t('25%')} {t('Discount')})</option>
				</select>
			</div>
			<ul>
				{loading ? <strong>{t('PleaseWait')}</strong> :
					plans.filter(q => selectedVideoLimit === '' ? true : q.video_limit === Number(selectedVideoLimit))
						.filter(q => selectedUserLimit === '' ? true : q.max_user === Number(selectedUserLimit))
						.map(((plan) => {
							return (
								<li key={plan.public_id} className={`plan-item`}>
									<h5>{plan.name} {t('User')}</h5>
									<div className={'plan-details'}>
										<ul>
											<li>{plan.video_limit} {t('ConcurrentLiveVideo')}</li>
											<li>{plan.max_user} {t('ConcurrentUser')}</li>
											<li>{t('UnlimitedRooms')}</li>
											<li>{t('SpecialPanel')}</li>
											<li>{t('ConcurrentEvent')}</li>
											<li>{t('24-HourSupport')}</li>
										</ul>
									</div>
									<div className={'plan-btns'}>
										{selectedPercent !== 1 && <em>{digits(Math.round(plan.finalAmount  * selectedMonth))} {t('Tooman')}</em>}
										<strong>{digits(Math.round(plan.finalAmount * selectedPercent * selectedMonth))}  {t('Tooman')}</strong>
										<button onClick={()=>{
											if(typeof window !== "undefined") window.location.href=`${process.env.NODE_ENV !== "production" ? 'http://localhost:3002/plan?plan_id' : 'https://panel.bellmeet.com/plan?plan_id'}=${plan.public_id}`
										}}>{t('Buy')}</button>
									</div>
								</li>
							)
						}))
				}
			</ul>
		</div>
	)
}

export default Plan